import IconButton from '@material-ui/core/IconButton';
import IconMore from '@material-ui/icons/MoreHoriz';
import React from 'react';
import { ListItemTextBase } from '../../../../../components/common/Containers';
import { ContextMenuListItem, Popover } from '../../../../../components/common/Dialogs/Popover';
import Typography from '../../../../../components/common/Typography';
import ConfirmDialog from '../../../../../components/generics/Confirm/Dialog';
import useBooleanHandlers from '../../../../../hooks/useBooleanHandlers';
import usePopover from '../../../../../hooks/usePopover';
import { useTrans } from '../../../../../services/i18n';
import SavePipelineStageForm from '../../../../../components/forms/SavePipelineStageForm';
import AddOpportunityManuallyForm from '../../../../../components/forms/AddOpportunityManuallyForm';
import { actions } from '../../../../../store/pipelinesDetails';
import { useDispatch } from 'react-redux';
import { useAlertContext } from '../../../../../contexts/AlertContext';
import { PIPELINE_DETAILS_FIXED_STAGES } from '../../../../../utils/constants';
import { config } from '../../../../../services/api';
import connect from '../../connect';

const StageItemMenu = ({ item, title, pending, onDelete, onEdit, addStages, index, settings }) => {
  const { successAlert, infoAlert } = useAlertContext();
  const { trans } = useTrans();
  const [anchorEl, onOpenPopover, onClosePopover] = usePopover();
  const [openConfirm, onOpenConfirm, onCloseConfirm] = useBooleanHandlers();
  const [openEdit, onOpenEdit, onCloseEdit] = useBooleanHandlers();
  const [openAddManual, onOpenAddManual, onCloseAddManual] = useBooleanHandlers();
  const dispatch = useDispatch();

  const handleSort = (sortBy) => {
    dispatch(actions.sortPursuitsBy({ sortBy, stageId: item.id }));
  };

  const handleAddManualOpportunity = (formData) => {
    dispatch(actions.addToPipeline(formData))
      .unwrap()
      .then((result) => {
        if (result?.alreadyExists) {
          infoAlert(result.message || trans('opportunity-already-in-pipeline'));
          return;
        }
        successAlert(trans('pursuit-added-successfully'));

        // Upload file to S3 and create DB record after pursuit is created
        if (formData.uploadedFile && result.pursuit) {
          const body = new FormData();
          body.append('pursuitId', result.pursuit.id);
          body.append('file', formData.uploadedFile);

          fetch(`${config.apiHost}/upload-pursuit-file`, { method: 'POST', body }).catch((err) =>
            // eslint-disable-next-line no-console
            console.error('File upload failed:', err)
          );
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error adding pursuit:', error);
      });
  };

  return (
    !!item && (
      <>
        <IconButton color="inherit" onClick={onOpenPopover} size="small">
          <IconMore />
        </IconButton>

        {<SavePipelineStageForm item={item} open={openEdit} onClose={onCloseEdit} onEdit={onEdit} />}
        <AddOpportunityManuallyForm
          open={openAddManual}
          onClose={onCloseAddManual}
          onSubmit={handleAddManualOpportunity}
          stageId={item.id}
          pipelineId={settings.pipeline?.id}
        />
        <Popover open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={onClosePopover}>
          <ContextMenuListItem size="normal">
            <Typography variant="caption" color="hint">
              {trans('Actions')}
            </Typography>
          </ContextMenuListItem>

          {/* {PIPELINE_DETAILS_FIXED_STAGES.includes(item.type) ? null : ( */}
          <ContextMenuListItem button onClick={onOpenEdit} onClickCB={onClosePopover} size="normal">
            <ListItemTextBase>{trans('EditStage')}</ListItemTextBase>
          </ContextMenuListItem>
          {/* )} */}

          {PIPELINE_DETAILS_FIXED_STAGES.includes(item.type) ? null : (
            <ContextMenuListItem
              button
              onClick={() => {
                addStages?.({ index: index });
                successAlert('Stage added!');
              }}
              onClickCB={onClosePopover}
              size="normal"
            >
              <ListItemTextBase>{trans('AddStageBefore')}</ListItemTextBase>
            </ContextMenuListItem>
          )}

          <ContextMenuListItem
            button
            onClick={() => {
              addStages?.({ index: index + 1 });
              successAlert('Stage added!');
            }}
            onClickCB={onClosePopover}
            size="normal"
          >
            <ListItemTextBase>{trans('AddStageAfter')}</ListItemTextBase>
          </ContextMenuListItem>

          <ContextMenuListItem button onClick={onOpenAddManual} onClickCB={onClosePopover} size="normal">
            <ListItemTextBase>{trans('add-opportunity-manually')}</ListItemTextBase>
          </ContextMenuListItem>

          {!PIPELINE_DETAILS_FIXED_STAGES.includes(item.type) && ['Owner', 'Admin'].includes(settings.userRole) && (
            <ContextMenuListItem button onClick={onOpenConfirm} onClickCB={onClosePopover} size="normal">
              <ListItemTextBase>{trans('DeleteStage')}</ListItemTextBase>
            </ContextMenuListItem>
          )}

          <ContextMenuListItem size="normal">
            <Typography variant="caption" color="hint">
              {trans('sort-by')}
            </Typography>
          </ContextMenuListItem>
          <ContextMenuListItem
            button
            onClick={() => handleSort('pursuitName')}
            onClickCB={onClosePopover}
            size="normal"
          >
            <ListItemTextBase>{trans('name')}</ListItemTextBase>
          </ContextMenuListItem>
          <ContextMenuListItem button onClick={() => handleSort('dueDate')} onClickCB={onClosePopover} size="normal">
            <ListItemTextBase>{trans('due-date')}</ListItemTextBase>
          </ContextMenuListItem>
          <ContextMenuListItem button onClick={() => handleSort('updatedAt')} onClickCB={onClosePopover} size="normal">
            <ListItemTextBase>{trans('updated')}</ListItemTextBase>
          </ContextMenuListItem>
        </Popover>

        <ConfirmDialog
          open={openConfirm}
          onClose={onCloseConfirm}
          onConfirm={() => {
            onDelete?.({ id: item.id }).then(onCloseConfirm);
          }}
          pending={pending}
          title={trans('DeleteStage')}
        >
          <Typography color="hint">{trans('delete')}</Typography>
          <Typography color="primary">{title}</Typography>
        </ConfirmDialog>
      </>
    )
  );
};

export default connect(StageItemMenu);
